import { createStore } from 'vuex'
import app from './modules/app'
import dictionary from './modules/dictionary'
import user from './modules/user'

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app,
    dictionary,
    user
  }
})
